import { Component, Vue } from 'vue-property-decorator'
import Control from '@/helpers/control'
import api from '@/helpers/fetch'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import Loader from '@/components/Loader/index.vue'
import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'

@Component({
	components: {
		FieldPortal,
		ManageArray,
		Loader,
		MessageErrorAlert,
	},
	// mixins: [validationMixin],
})
export default class GerenciarLamina extends Vue {
	laminaId: string | null = null
	fields: any[] = []
	lamina: null | any = null
	iframe = false

	async mounted() {
		this.laminaId = this.$route.params.laminaId
		await this.fetchData(this.laminaId)
	}

	onSubmit(field) {
		const name = field.field
		const form: any = this.$refs['form-' + name]

		form[0].classList.add('loading')

		return () => {
			// console.info('event', event)
		}
	}

	async fetchData(laminaId) {
		const res = await api.get('/api/laminas/' + laminaId)
		if (res.ok) {
			const lamina = res.data[0]
			this.lamina = lamina
			this.fields = this.order.map((field) => {
				if (this.lamina) {
					return {
						field,
						value: this.lamina[field],
					}
				}
			})

			this.iframe = true
		}
	}

	focus(field) {
		Vue.set(field, 'rows', 10)
	}

	blur(field) {
		Vue.set(field, 'rows', 2)
	}

	order = [
		'descricao',
		'objetivos',
		'beneficios',
		'documentos',
		'is_adm',
		'metodologia',
		'diferenciais',
		'tema_afetado',
		'precedentes',
	]

	humanName = {
		descricao: 'Descrição',
		objetivos: 'Objetivos',
		beneficios: 'Benefícios',
		documentos: 'Documentos',
		metodologia: 'Metodologia',
		diferenciais: 'Diferenciais',
		tema_afetado: 'Tema afetado',
		precedentes: 'Precedentes',
		is_adm: 'É administrativo?',
	}

	control = new Control()

	async input(field, $event) {
		const fieldName = field.field
		const value = $event?.target?.value || $event

		const saveLamina = {
			id: this.laminaId,
		}
		saveLamina[fieldName] = value

		const form: any = this.$refs['form-' + fieldName]

		form[0].classList.add('loading')

		const res = await api.put('/api/laminas/' + this.laminaId, saveLamina)
		if (res.ok) {
			this.iframe = false
			await Vue.nextTick()
			this.iframe = true

			form[0].classList.remove('loading')
		}
	}

	debouncedInput(field, $event) {
		const debouncedChange = this.control.debounce(this.input, 1000)
		debouncedChange(field, $event)
	}

	async inputFieldPortal(fieldName, value) {
		await this.input({ field: fieldName }, value)
		this.lamina = null

		this.fetchData(this.laminaId)
	}

	uploading = false
	addedFiles: any = []
	async onFileInput($event) {
		$event.preventDefault()
		const filesInput: any = $event.target
		const files = filesInput.files

		for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
			const file = files[fileIndex]
			const name = file.name
			const formattedSize = formatBytes(file.size)

			this.addedFiles.push({
				file,
				name,
				size: formattedSize,
			})
		}

		await this.uploadFiles()
	}

	fileInputKey = 0
	fileInputError = false
	async uploadFiles() {
		const form: any = this.$refs?.fileForm?.[0]
		if (form) {
			const formData = new FormData(form)

			this.fileInputError = false

			const resp = await fetch('/api/laminas/upload', {
				method: 'POST',
				body: formData,
			})

			const respJson = await resp.json()

			if (respJson && respJson.ok) {
				this.laminaId = this.$route.params.laminaId
				await this.fetchData(this.laminaId)
			} else {
				this.fileInputError = respJson.msg
			}

			Vue.set(this, 'addedFiles', [])

			this.clearInput()
		}
	}

	async onUpdate(value, field) {
		const component: any = this.$refs[field]?.[0]
		if (component && component?.setLoading) {
			component.setLoading(true)

			await this.input({ field }, value)

			component.setLoading(false)
			component.setSuccess(true)
		}
	}

	precedenteToDelete: any = null
	onDeleteClick(precedente) {
		this.precedenteToDelete = precedente
		this.$bvModal.show('modal-confirm-delete-precedentes')
	}

	deleting = false
	async onDelete(precedente) {
		this.deleting = true

		const res = await api.delete('/api/laminas/upload', {
			Key: precedente.Key,
		})

		if (res.ok) {
			this.deleting = false

			this.$bvModal.hide('modal-confirm-delete-precedentes')

			this.laminaId = this.$route.params.laminaId

			await this.fetchData(this.laminaId)
		}
	}

	clearInput() {
		const input: any = this.$refs?.fileInput?.[0]

		input.value = null
	}

	getPdfUrl() {
		return '/api/laminas/' + this.laminaId + '/pdf'
		// this.laminaId = this.$route.params.laminaId
		/*
		if (window.location.host.includes('localhost')) {
			url = 'http://localhost:3000/generate-pdf/lamina/' + this.laminaId
		} else {
			url = '/generate-pdf/lamina/' + this.laminaId
		}

		return url
		*/

	}
}

function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
